export default "__VITE_ASSET__3dce76f3__"